var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchAwsWickr32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture/32/Arch_AWS-Wickr_32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD0816",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5252",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture/32/Arch_AWS-Wickr_32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture-BG/32/Business-Applications",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon-Service/32/AWS-Wickr_32",
    transform: "translate(7.000000, 6.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,17.5 C6,18.327 6.673,19 7.5,19 L18.5,19 C19.327,19 20,18.327 20,17.5 L20,8.5 C20,7.673 19.327,7 18.5,7 L7.5,7 C6.673,7 6,7.673 6,8.5 L6,17.5 Z M9,6 L17,6 L17,3.75 C17,2.233 15.584,1 13.844,1 L12.156,1 C10.416,1 9,2.233 9,3.75 L9,6 Z M7.5,6 L8,6 L8,3.75 C8,1.682 9.864,0 12.156,0 L13.844,0 C16.136,0 18,1.682 18,3.75 L18,6 L18.5,6 C19.879,6 21,7.122 21,8.5 L21,17.5 C21,18.878 19.879,20 18.5,20 L7.5,20 C6.121,20 5,18.878 5,17.5 L5,8.5 C5,7.122 6.121,6 7.5,6 L7.5,6 Z M23.5,4 L19,4 L19,5 L23.5,5 C24.327,5 25,5.673 25,6.5 L25,21.5 C25,22.327 24.327,23 23.5,23 L11.5,23 C11.224,23 11,23.224 11,23.5 L11,26.459 L6.812,23.109 C6.724,23.039 6.613,23 6.5,23 L2.5,23 C1.673,23 1,22.327 1,21.5 L1,6.5 C1,5.673 1.673,5 2.5,5 L7,5 L7,4 L2.5,4 C1.121,4 0,5.122 0,6.5 L0,21.5 C0,22.878 1.121,24 2.5,24 L6.324,24 L11.187,27.891 C11.278,27.963 11.389,28 11.5,28 C11.573,28 11.647,27.984 11.717,27.951 C11.89,27.867 12,27.692 12,27.5 L12,24 L23.5,24 C24.879,24 26,22.878 26,21.5 L26,6.5 C26,5.122 24.879,4 23.5,4 L23.5,4 Z M11.854,16.854 L17.854,10.854 L17.146,10.146 L11.146,16.146 L11.854,16.854 Z M8.854,15.854 L8.146,15.146 L14.146,9.146 L14.854,9.854 L8.854,15.854 Z",
    id: "Fill-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchAwsWickr32);
export default __webpack_public_path__ + "static/media/Arch_AWS-Wickr_32.76b2951cebbd37a64f0eafeeecedbe3e.svg";
export { ForwardRef as ReactComponent };